<script>
  import TextField from "../../utils/TextField.svelte";
  import { PHP } from "../../store";
  import { saveSettings, sendActivationEmail } from "../../api";
  import {SETTING_SAVE_TYPES} from "../../constants";
  import Message from "../../utils/Message.svelte";
  import Modal from "../../utils/Modal.svelte";
  import { activationValidators } from "../validators";
  import validate from "validate.js";

  export let submitSettings;

  let domain = $PHP.userBaseUrl
    .replace("http://", "")
    .replace("https://", "")
    .replace("www", "");
  if (domain.includes("/")) domain = domain.substring(0, domain.indexOf("/"));
  
  let form = { email: $PHP.email, domain: domain };
  let error = {
    email: "",
    domain: ""
  };
  let showModal = false;
  let inprogress = false;

  async function submitActivation() {
    error = validate(form, activationValidators, {
      format: "svelte",
      fullMessages: false
    });

    if (error) return;

    inprogress = true;

    const response = await sendActivationEmail(
      form.email,
      `${$PHP.adminUrl}?page=best_push_settings`
    );

    inprogress = false;

    if (response.status === 201) {
      showModal = true;
      await submitSettings(SETTING_SAVE_TYPES.GENERAL, { email: form.email });
    }
  }
</script>

<style>
  .submit {
    display: flex;
    justify-content: center;
    width: 100%;
  }
</style>

<div class="container is-fluid">

  <Message
    message="Plugin has been activated."
    type="is-success"
    show={$PHP.isActivated} />

  <Message
    message="plugin is not activated yet."
    type="is-danger"
    show={!$PHP.isActivated} />

  <Modal
    show={showModal}
    title="Activation"
    message="Thanks for entering your e-mail. We’ve sent you an activation
    e-mail. Please check your inbox and click on activation link in order to
    activate your account and sending notifications. " />

  <TextField
    title="Email"
    bind:value={form.email}
    error={(error || {}).email}
    placeholder="Email" />
  <TextField
    title="Domain"
    bind:value={form.domain}
    error={(error || {}).domain}
    placeholder="Domain" />
  <div class="field is-grouped submit">
    <p
      class="control"
      data-tooltip={$PHP.isActivated ? 'Plugin is already activated, are you sure to do this action again?' : undefined}>
      <button
        id="activation-login-submit"
        class="button is-success is-outlined"
        class:is-loading={inprogress}
        disabled={inprogress}
        on:click={submitActivation}>
        Send activation key
      </button>
    </p>
  </div>

</div>
